import React from "react";
import { Modal, Box } from "@mui/material";
import "./LoginModalComponent.css";

const LoginModalComponent = ({
  open,
  onClose,
  imageSrc,
  imageAlt = "Login Image",
  text,
  onLogin,
}) => {
  return (
    <Modal open={open} onClose={onClose} className="loginModalComponent__modal">
      <Box className="loginModalComponent__container">
        <div className="loginModalComponent__content">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="loginModalComponent__image"
          />
          <p className="loginModalComponent__text">{text}</p>
          <button className="loginModalComponent__button" onClick={onLogin}>
            Login
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default LoginModalComponent;
